import React, { useEffect } from "react";
import "./Advantage4.css";
import num4dark from "../images/num4-dark.png";

const Advantage4 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = document.querySelectorAll(".advantage4-1 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="advantage4-1">
      <div className="advantage4-2">
        <div className="img4-1 animate-side slide-right">
          <div
            className="logo-light"
            style={{
              backgroundImage: `url(${num4dark})`,
            }}
          />
        </div>

        <div className="advantage4-content animate-side slide-left">
          <h1>Custom-Tailored Engineering</h1>
          <div className="advantage4-3">
            <p>
              <label>Bespoke Functionality:</label>
              We build custom modules, automated workflows, and tailormade features designed around your unique operational requirements.<br/>
              <label>Custom API Integrations:</label>
              Seamlessly bridge legacy systems, payment gateways, and third-party tools into a cohesive software infrastructure.<br/>
              <label>Future-Proof Technology:</label>
              Engineered with modern, high-performance frameworks that guarantee fast load times, enterprise security, and effortless scalability as you grow.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advantage4;